import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { changeNumberInUse, configureNumberInUse } from "../../actions";
import PhoneNumberPicker from "../PhoneNumberPicker/PhoneNumberPicker";
import Softphone from "../Softphone/Softphone";

import { Box, Column, Grid } from "@twilio-paste/core";

function App() {
  const channelData = useSelector((state) => state.channelData);
  const numberInUse = useSelector((state) =>
    state.numberInUse ? state.numberInUse.phoneNumber : ""
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (channelData.phoneNumber) {
      dispatch(changeNumberInUse({ phoneNumber: channelData.phoneNumber }));
    }
  }, [channelData, dispatch]);

  return (
    <Box>
      {numberInUse ? (
        <Softphone numberInUse={numberInUse} />
      ) : (
        <Grid gutter="space30">
          <Column span={6} offset={3}>
            <PhoneNumberPicker
              configureNumberInUse={(number) =>
                dispatch(configureNumberInUse(number))
              }
            />
          </Column>
        </Grid>
      )}
    </Box>
  );
}

export default App;
